import { IconButton, Badge, makeStyles } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { ReservationService } from 'services';

const POLL_MS = 30000;

const useStyles = makeStyles({
  badge: {
    backgroundColor: '#1976d2',
    color: 'white',
    fontWeight: 600,
  },
});

/**
 * Header bell that surfaces the count of reservations stuck in
 * `requested` status. Polls every 30s. Click jumps to the Requests
 * tab via /reservations#requests — the Reservations view reads the
 * hash to set its initial tab.
 */
export const ReservationsBell: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    let active = true;
    const tick = () => {
      ReservationService.getAll({ status: 'requested' })
        .then((rows) => {
          if (active) setCount((rows || []).length);
        })
        .catch(() => {
          /* keep last known count, don't flash */
        });
    };
    tick();
    const id = window.setInterval(tick, POLL_MS);
    return () => {
      active = false;
      window.clearInterval(id);
    };
  }, []);

  const title =
    count > 0
      ? `${count} pending reservation request${count === 1 ? '' : 's'}`
      : 'No pending reservation requests';

  return (
    <IconButton
      color="inherit"
      onClick={() => history.push('/reservations#requests')}
      title={title}
      aria-label={title}
    >
      <Badge
        badgeContent={count}
        invisible={count === 0}
        classes={{ badge: classes.badge }}
      >
        <NotificationsIcon />
      </Badge>
    </IconButton>
  );
};
